import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { AuthContextType } from '@/types';

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export interface AuthProviderProps {
  children: ReactNode;
}
